import { AloftPrice, isUndefined } from '@aloft/toolkit-shared';

import { Typography } from '../../../summary/components/Typography.tsx';
import { hasAdjustments } from '../AdjustmentBreakdown/hasAdjustments.ts';
import { SummarySection } from '../SummarySection.tsx';
import { TitleAndExportToggleLockup } from '../TitleAndExportToggleLockup.tsx';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../types.ts';
import { AdjustmentBreakdownSiteValueCharts } from './AdjustmentBreakdownSiteValueCharts.tsx';
import { AdjustmentBreakdownSiteValueTable } from './AdjustmentBreakdownSiteValueTable.tsx';

export const AdjustmentBreakdownSiteValue = (props: Tkv2PairedCostSummaryInterfaceV2) => {
  const commentaryProps = props.exportableCommentaries.site;

  const subjectSiteVal = props.results.subject?.totals?.site.marketAdjusted.siteValue.totalCost;
  /**
   * Skip rendering the site breakdown table if both are true:
   * 1. No site adjustments exist
   * 2. Subject site value is zero (either hasn't been costed or manually entered as "0")
   *
   * Currently no better way to check if the site breakdown is valid.
   */
  if (
    !hasAdjustments(props.results, 'site') &&
    (isUndefined(subjectSiteVal) || subjectSiteVal?.le(AloftPrice.zero))
  ) {
    return null;
  }
  return (
    <SummarySection>
      <TitleAndExportToggleLockup
        {...props}
        title="Site Extraction Adjustments"
        id="isSiteCommentaryInExport"
        commentary={commentaryProps}
        variant="h1"
      />
      <Typography variant="body1">
        The improvements were depreciated and the site values extracted for each comparable sale.
        Using this data, the subject's site value was estimated. These site values represent the
        combined market value of Site Size, Location, View, and Site Improvements. The site
        adjustments are derived by comparing the site values of the comparables against the subject.
      </Typography>
      <AdjustmentBreakdownSiteValueTable {...props} />
      <AdjustmentBreakdownSiteValueCharts {...props} />
    </SummarySection>
  );
};
